import React, { memo, useState } from "react";
import { ProgressBar } from "react-bootstrap";

function DownloadProgressPop(props) {
  const [dwProgress, setDwlProgress, dwShow, setDwShow, dwText, setDwText] =
    props.options;

  return (
    <div
      style={{
        zIndex: "10000",
        height: "60px",
        width: "400px",
        // display: "flex",
        position: "absolute",
        bottom: "10px",
        right: "10px",
        background: "red",
        justifyContent: "center",
        alignItems: "center",
        visibility: dwShow ? "visible" : "hidden",
        padding: "5px 10px 10px 10px",
        textAlign: "center",
        color: "white",
        opacity: "0.8",
        borderRadius: "5px",
      }}
    >
      <div>{dwText}%</div>
      <ProgressBar variant="info" now={dwProgress} max={100} animated={true} />
    </div>
  );
}

export default memo(DownloadProgressPop);
// const divStyle = {zIndex:'5000', heig}
